import { Typography, TypographyProps } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { CSSProperties, ReactNode } from 'react';

interface TextProps extends TypographyProps {
  children?: ReactNode;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
  primary?: boolean;
  secondary?: boolean;
  color?: string;
  textAlign?: 'center' | 'right' | 'left' | 'inherit' | 'justify';
  fontSize?: number | string;
  fontWeight?: number;
  fontFamily?: string;
  onClick?: () => void;
}

export const Text = ({
  children,
  style,
  sx = {},
  primary = false,
  secondary = false,
  color,
  textAlign,
  fontSize,
  fontWeight,
  fontFamily,
  onClick,
  variant = 'body2',
  ...rest
}: TextProps) => {
  const theme = useTheme();

  const getTextColor = () => {
    if (color) return color;
    if (primary) return theme.palette.text.primary;
    if (secondary) return theme.palette.text.secondary;
    return undefined;
  };

  const customStyles: SxProps<Theme> = !variant
    ? {
        fontSize,
        fontWeight,
        fontFamily,
      }
    : {};

  return (
    <Typography
      variant={variant}
      align={textAlign}
      color={getTextColor()}
      sx={{ ...customStyles, ...sx }}
      onClick={onClick}
      style={{ ...style }}
      {...rest}
    >
      {children}
    </Typography>
  );
};
